
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.5 17.5h-16A1.5 1.5 0 010 16V4a1.5 1.5 0 011.5-1.5h16A1.5 1.5 0 0119 4v12a1.5 1.5 0 01-1.5 1.5zm-16-14A.5.5 0 001 4v12a.5.5 0 00.5.5h16a.5.5 0 00.5-.5V4a.5.5 0 00-.5-.5z"}}),_c('path',{attrs:{"d":"M22.5 21.5h-16A1.5 1.5 0 015 20v-1a.5.5 0 011 0v1a.5.5 0 00.5.5h16a.5.5 0 00.5-.5V8a.5.5 0 00-.5-.5h-2a.5.5 0 010-1h2A1.5 1.5 0 0124 8v12a1.5 1.5 0 01-1.5 1.5z"}})])
          )
        }
      }
    